export const checkIsNightmareJS = (): boolean => {
  return '__nightmare' in window && !!window.__nightmare;
};

export const checkIsPhantomJS = (): boolean => {
  return 'callPhantom' in window || '_phantom' in window || 'phantom' in window;
};

export const SELENIUM_WINDOW_INDICATORS = ['webdriver', '_Selenium_IDE_Recorder', 'callSelenium', '_selenium'];
export const SELENIUM_DOCUMENT_INDICATORS = [
  '__webdriver_script_fn',
  '__driver_evaluate',
  '__webdriver_evaluate',
  '__selenium_evaluate',
  '__fxdriver_evaluate',
  '__driver_unwrapped',
  '__webdriver_unwrapped',
  '__selenium_unwrapped',
  '__fxdriver_unwrapped',
  '__webdriver_script_func',
];

export const checkIsSelenium = (): boolean => {
  return (
    SELENIUM_WINDOW_INDICATORS.some(indicator => indicator in window) ||
    SELENIUM_DOCUMENT_INDICATORS.some(indicator => indicator in document) ||
    document.documentElement.getAttribute('selenium') !== null ||
    document.documentElement.getAttribute('webdriver') !== null ||
    document.documentElement.getAttribute('driver') !== null
  );
};

export const checkIsWebDriver = (): boolean => {
  return typeof navigator === 'object' && navigator.webdriver !== undefined && navigator.webdriver;
};
